import React, { useCallback } from "react";
import PropTypes from "prop-types";
import "./CustomTooltip.scss";

const CustomTooltip = (props) => {
  const getPercentage = useCallback(
    (p) => {
      if (!props.totalSum) {
        return null;
      }

      const percentage = ((p.value / props.totalSum) * 100).toFixed(2);

      return <span className="percentage">({percentage}%)</span>;
    },
    [props.totalSum]
  );

  if (props.active && props.payload) {
    return (
      <div className="tooltip">
        {props.isSingleValue ? (
          <p className="value">
            <span>{props.label || props.payload[0].name}</span>:
            <span>
              {props.payload[0].value}
              {getPercentage(props.payload[0])}
            </span>
          </p>
        ) : (
          <>
            <p className="label">{props.label}</p>  
            {props.payload.map((p) => (
              <p className="value" key={p.dataKey}>
                <span style={{ color: p.stroke || p.color }}>{p.name}</span>:
                <span>
                  {p.value}
                  {getPercentage(p)}
                </span>
              </p>
            ))}
          </>
        )}
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  isSingleValue: PropTypes.bool.isRequired,
  active: PropTypes.bool,
  payload: PropTypes.any,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  totalSum: PropTypes.number,
};

export default CustomTooltip;
